<script>
import { defineComponent, h, resolveComponent } from 'vue'

export default defineComponent({
  name: 'Air8DynamicDate',
  aliasName: 'a8-d-date',

  inheritAttrs: false,

  render () {
    return h(resolveComponent('tz-date'), this.$attrs, this.$slots)
  }
})
</script>
